__turbopack_context__.v({
  "sizePanelContainer": "ClothingSizeRefinement-module-scss-module__T7ob0q__sizePanelContainer",
  "sizePanelContainerTitle": "ClothingSizeRefinement-module-scss-module__T7ob0q__sizePanelContainerTitle",
  "sizes": "ClothingSizeRefinement-module-scss-module__T7ob0q__sizes",
});
